import useCountUp from "../hooks/useCountUp";

const AnimatedCounter = ({ value, suffix = "" }) => {
  const numericPart = parseInt(value, 10);
  const textSuffix = value.replace(/[0-9]/g, "") + suffix;
  const isNumeric = !isNaN(numericPart) && numericPart > 0;

  const { count, ref } = useCountUp(
    isNumeric ? numericPart : 0,
    1800,
    true
  );

  if (!isNumeric) {
    return <span>{value}</span>;
  }

  return (
    <span ref={ref}>
      {count}
      {textSuffix}
    </span>
  );
};

export default AnimatedCounter;
